var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehindAhead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#C5DCE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 10,
    height: 10,
    fill: "#C5DCE3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 10,
    height: 9,
    fill: "#C5DCE3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 13,
    height: 13,
    fill: "#0C9CB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehindAhead);
export default __webpack_public_path__ + "static/media/behindAhead.446d7e258ea636938a4d072ac9c918e1.svg";
export { ForwardRef as ReactComponent };